import { FunctionComponent, useMemo } from 'react';

import { SearchIndex } from '@kanda-libs/ks-frontend-services';

interface TabsProps {
  index: SearchIndex;
  tab: SearchIndex;
  onTabClick: (idx: SearchIndex) => void;
}

const Tab: FunctionComponent<TabsProps> = function ({
  index,
  tab,
  onTabClick,
}) {
  const disabled = useMemo(() => tab === index, [tab, index]);

  const className = useMemo(
    () =>
      [
        'px-3 py-2 w-full border-l border-b border-neutral-300 first:border-l-0 text-14-22-em',
        disabled
          ? 'bg-green-100 text-green-500'
          : 'bg-neutral-000 text-neutral-700',
      ].join(' '),
    [disabled],
  );

  return (
    <button
      type="button"
      onClick={() => onTabClick(tab)}
      disabled={disabled}
      className={className}
    >
      {tab}
    </button>
  );
};

export default Tab;
